import * as React from 'react';

var AuthContext = React.createContext(null);
var AuthContextConsumer = AuthContext.Consumer;

export { AuthContextConsumer, AuthContext as default };
